import { render, staticRenderFns } from "./base-loader.vue?vue&type=template&id=f2de37a4&"
import script from "./base-loader.vue?vue&type=script&lang=js&"
export * from "./base-loader.vue?vue&type=script&lang=js&"
import style0 from "./base-loader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports